import src from "IMAGE";
export default { src, width: 1630, height: 247, blurWidth: 0, blurHeight: 0};
